import * as amplitude from '@amplitude/analytics-browser';

if (typeof window !== 'undefined') {
    // Inicializa o cliente do Amplitude
    amplitude.init(process.env.REACT_APP_AMPLITUDE_KEY_PRODUCTION);
}

const amplitudeError = (error, message, stack) => {
    if (typeof window !== 'undefined') {
        // Envia o erro para o Amplitude
        amplitude.track('Error', {
            error: error.toString(), // Certifique-se de converter o erro para string
            message: message || 'Erro sem mensagem', // Se não houver mensagem, coloque um valor default
            stack: stack || 'Sem stack disponível', // Caso não tenha stack, forneça um valor default
        });
    }
};

export { amplitudeError };
